export default "__VITE_ASSET__CIyBJAq6__"